import styled from 'styled-components';
import { Flex } from 'UI';

export const OrderHeaderBar = styled(Flex)`
  background: #eef2f5b2;
  border-radius: 13px;
  padding: 20px;
`;

export const HeaderRow = styled(Flex)`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 6px 20px;
  max-width: 400px;

  /* value cells (every even child) aligned to the right */
  & > *:nth-child(even) {
    text-align: right;
    justify-self: end;
  }
`;
